import React from 'react';
import { SonarTagDisplay } from '@ui/tags';
import { Space } from 'antd';
import { useSonarObjectReference } from '@hooks';
export const TagsColumn = ({ sonarObjectId }) => {
    var _a, _b;
    const tagIds = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.tagIds) !== null && _b !== void 0 ? _b : [];
    return (React.createElement(Space, { size: 4, wrap: true }, tagIds.map((id) => React.createElement(SonarTagDisplay, { key: `${id}-tag`, tagId: id }))));
};
